namespace advisorop.components.advisor {
    
    class InvestorDetailsController {
        $router;
        model: domains.IInvestor;
        refreshHouseholds: boolean;
        rtqs: domains.IRTQ;
        investorId: number = 0;
        proposals: Array<domains.IProposal>;

        static $inject = ["advisorService"];
        constructor(private advisorService: services.AdvisorService) {            
        }

        rtqTabSelected(): void {
            this.advisorService.getRTQs(this.investorId).success((data) => {
                this.rtqs = <domains.IRTQ>data;
            }).error((data, status) => {
                toastr.error("RTQ error " + status + " : " + data);
            });
        };

        proposalsTabSelected(): void {
            this.advisorService.getProposalsByTitle(this.investorId).success((data) => {
                this.proposals = data;
            }).error((data, status) => {
                toastr.error("Proposals error " + status + " : " + data);
            });
        };
        
        holdingsTablSelected(): void {
            this.refreshHouseholds = !this.refreshHouseholds;
        };


        $onInit(): void {            
        };

        $routerOnActivate(next, previous) {

            this.investorId = <number>next.params.id;

            this.advisorService.getInvestor(this.investorId).success((data) => {
                this.model = <domains.IInvestor>data;
            }).error((data, status) => {
                toastr.error("Investor error " + status + " : " + data);
            });
        }
    }


    class InvestorDetails implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.controller = InvestorDetailsController;
            this.controllerAs = "vm";
            this.bindings = {
                $router: "<"
            };
            this.templateUrl = "spa/advisor-module/views/investor-details.html";
        }

    }
    angular.module(Constants.APP).component("investorDetails", new InvestorDetails());


}